// The community config form seeds the "Sub Required" checkbox to ticked when a
// community has no stored config.subRequired. That display is deliberate and
// stays as it is.
export const SUB_REQUIRED_SEEDED_DEFAULT = true;

// Most live communities have NO config.subRequired key at all, and the app
// reads an absent key as "not gated". Because the checkbox seeds itself to
// ticked, writing values.subRequired on every save would turn that absent key
// into a stored true and silently lock the community behind the hard web
// paywall, just for saving a colour or a title.
//
// So the key is written only when it already exists in Firestore, or when the
// coach moved the checkbox away from the seeded default. A coach who ticks and
// then unticks lands back on the default and writes nothing, which is the
// intended no-op: the comparison is against the seeded value, not against a
// click count.
//
// Create mode is untouched. There is no stored document to preserve there, and
// a new community whose box is ticked should be gated, so the value is always
// written.
//
// This lives in its own module, with no firebase import, so the test can
// exercise it without mocking the live SDK. The repo has no @types/jest, and a
// test that touches the `jest` global fails the production build.
export const buildSubRequiredPatch = (
  storedSubRequired: boolean | undefined,
  formSubRequired: boolean,
  isEditingExisting: boolean
): { subRequired?: boolean } => {
  if (!isEditingExisting) return { subRequired: formSubRequired };
  if (typeof storedSubRequired === "boolean") {
    return { subRequired: formSubRequired };
  }
  if (formSubRequired === SUB_REQUIRED_SEEDED_DEFAULT) return {};
  return { subRequired: formSubRequired };
};
